<!--
패킹 컴포넌트 > 출고보류작업
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <!-- stepper -->
            <div class="uk-modal-header">
                <div class="stepper">
                    <div
                        class="step"
                        :class="step1Class"
                    >
                        <div class="circle">1</div>
                        <div class="label">출고보류 보관장소</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step2Class"
                    >
                        <div class="circle">2</div>
                        <div class="label">라벨출력</div>
                    </div>
                </div>
            </div>


            <div class="uk-modal-body uk-padding-small">

                <!-- 보관장소 -->
                <div v-if="currStep === 1">

                    <app-input-ex
                        class="uk-margin-bottom"
                        type="text"
                        input-size="large"

                        name="memo"
                        v-model="storage"
                        label="출고보류 보관장소"

                        required-layout="label-left"

                        placeholder="BOX의 보관장소를 입력하세요"
                    > </app-input-ex>

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large"
                            v-on:click="saveStorage"
                        >
                            <span uk-icon="icon: check"></span>
                            보관장소 입력
                        </button>
                    </div>
                </div>

                <!-- 라벨출력 -->
                <div v-if="currStep === 2">
                    <div class="uk-text-large uk-text-center uk-margin-bottom">
                        라벨 부착 후 보관장소에 갖다놓으세요
                    </div>

                    <div class="uk-text-large3 uk-text-center uk-margin-bottom uk-text-primary">
                        {{ storage }}
                    </div>

                    <div class="uk-text-center uk-margin-bottom">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large"
                            onclick="$.app.print.shipout_hold_label(arguments);"
                            :data-house-id="houseId"
                            title="출고보류 라벨을 출력합니다"
                        >
                            <i class="material-icons">print</i>
                            <span class="text">PRINT HOLD-LABEL (출고보류라벨)</span>
                        </button>
                    </div>

                    <hr />

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large uk-margin-right"
                            v-on:click="currStep = 1"
                        >
                            <i class="material-icons">keyboard_arrow_left</i>
                            뒤로 (보관장소 수정)
                        </button>
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large uk-modal-close"
                        >
                            <i class="material-icons">check</i>
                            완료
                        </button>
                    </div>
                </div>

            </div>



        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                /**
                 * 보관장소
                 */
                storage: null,

                // (int) 하우스ID
                houseId: null,

                /**
                 * (int) 진행단계
                 *       1~2
                 **/
                currStep: 1,
            };
        },
        computed: {
            // 스텝1 클래스계산
            step1Class: function () {
                let step = 1;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝2 클래스계산
            step2Class: function () {
                let step = 2;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
        },
        methods: {

            /**
             * 폼 띄우기
             */
            form(house_id) {
                this.houseId = house_id;

                this.load();
            },

            /**
             * load
             */
            load() {
                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/houses/' + this.houseId + '/storage',
                        data: {
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.storage = response.storage;

                    // 폼 띄우기
                    UIkit.modal(this.$el).show();

                });
            },

            /**
             * 보관장소 저장
             */
            saveStorage() {
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/houses/' + this.houseId + '/storage',
                        data: {
                            '_token': this.csrfToken,
                            'storage': this.storage,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.currStep = 2;
                });
            },


        },
    }
</script>

<style lang="scss" scoped>
    /*
    stepper css
    https://codepen.io/shanejdonnelly/pen/wJqgQR?page=3
    */
    .stepper{
        clear: left;
        float: left;
        font-size: 1rem;
        margin: 10px;
    }

    .step{
        float: left;
    //    font-size: 15px;
        margin: 0 12px;
    }

    .divider{ border-bottom: 1px solid #cfcfcf; float: left; height: 0.75rem; margin: 0 12px; width: 3rem; }

    .circle{
        background: #cfcfcf;
        border-radius: 50%;
        color: #ffffff;
        float: left;
        height: 1.5rem;
        line-height: 1.5rem;
        text-align: center;
        width: 1.5rem;
    }

    .label{ color: #cfcfcf; float: left; line-height: 24px; margin-left: 8px; }

    .active{
        .circle{ background: #0f7ae5; }
        .label{ color: #0f7ae5; font-weight: 400; }
    }

    .complete{
        .circle{
            background: #666;
        }
        .label{
            color: #666;
            text-decoration-line: line-through;
        }
    }
</style>